// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React, {useCallback} from 'react';

import {useProjectParams} from '../../pages/ProjectPage/useProjectParams';
import {useIsInLoadedReportContext} from '../../pages/ReportPage/LoadedReportContext';
import type * as PanelTypes from '../../state/views/panel/types';
import type * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {type PanelType} from '../../util/panelTypes';
import {useRampFlagMetricChangeNotifications} from '../../util/rampFeatureFlags/rampFeatureFlags';
import {useAccountSelectorContext} from '../Search/SearchNav/AccountSelectorContextProvider';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';
import {StyledButtonWrapper} from './PanelActions.style';

/**
 * This is soon to be deprecated when we have a ReportPanelHeader created.
 */
export const PanelRunMetricButton = ({
  entityName,
  panelBankSectionConfigRef,
  panelRef,
  panelType,
}: {
  entityName: string;
  /**
   * Run metric button can only appear in a workspace and not reports.
   * TODO: Improve type so panelBankSectionConfigRef cannot be undefined because
   * that implies we are also using this in report panels.
   */
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref | undefined;
  panelRef: PanelTypes.Ref;
  panelType: PanelType;
}) => {
  const {selectedAccount} = useAccountSelectorContext();
  const orgName = selectedAccount?.name ?? '';

  const {data: runMetricNotificationEnabled} =
    useRampFlagMetricChangeNotifications(orgName, entityName);

  const isInReport = useIsInLoadedReportContext();

  if (
    panelType !== 'Run History Line Plot' ||
    !runMetricNotificationEnabled ||
    isInReport
  ) {
    return null;
  }

  return (
    <WorkspacePanelRunMetricButton
      panelBankSectionConfigRef={panelBankSectionConfigRef}
      panelRef={panelRef}
    />
  );
};
const RunMetricButton = ({
  buttonSize,
  onClick,
}: {
  buttonSize: 'medium' | 'small';
  onClick: () => void;
}) => {
  return (
    <Tooltip
      content={
        <div className="flex items-center gap-4">Create alert automation</div>
      }
      position="top center"
      trigger={
        <StyledButtonWrapper>
          <Button
            icon="bell-notifications"
            variant="ghost"
            aria-label="Create alert automation"
            size={buttonSize}
            onClick={onClick}
          />
        </StyledButtonWrapper>
      }
    />
  );
};

/**
 * This can be consolidated with the WorkspacePanelRunMetricButton once we
 * have a ReporPanelHeader to work with.
 */
export const FullScreenPanelRunMetricButton = ({
  panelBankSectionConfigRef,
  panelRef,
  panelType,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  panelRef: PanelTypes.Ref;
  panelType: PanelType;
}) => {
  const {selectedAccount} = useAccountSelectorContext();
  const orgName = selectedAccount?.name ?? '';

  const {entityName} = useProjectParams();
  const {data: runMetricNotificationEnabled} =
    useRampFlagMetricChangeNotifications(orgName, entityName);

  const {openWorkspaceDrawer} = useWorkspaceDrawerContext();

  const onClick = useCallback(() => {
    openWorkspaceDrawer('create-trigger', panelBankSectionConfigRef, panelRef);
  }, [openWorkspaceDrawer, panelBankSectionConfigRef, panelRef]);

  if (panelType !== 'Run History Line Plot' || !runMetricNotificationEnabled) {
    return null;
  }

  return <RunMetricButton buttonSize="medium" onClick={onClick} />;
};

const WorkspacePanelRunMetricButton = ({
  panelBankSectionConfigRef,
  panelRef,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref | undefined;
  panelRef: PanelTypes.Ref;
}) => {
  const {openWorkspaceDrawer} = useWorkspaceDrawerContext();

  const onClick = useCallback(() => {
    openWorkspaceDrawer('create-trigger', panelBankSectionConfigRef, panelRef);
  }, [openWorkspaceDrawer, panelBankSectionConfigRef, panelRef]);

  return <RunMetricButton buttonSize="small" onClick={onClick} />;
};
